import { SPECIAL_VALUE } from '../../../../helpers/address';

const disabledValues = [
  SPECIAL_VALUE.error,
  SPECIAL_VALUE.notFound,
  SPECIAL_VALUE.loading,
];

const checkForDisabledValue = (value) => disabledValues.includes(value);

export default checkForDisabledValue;
